import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetOrgUsersForSuperAdminCheckQueryVariables = Types.Exact<{
  where: Types.Users_Bool_Exp;
}>;


export type GetOrgUsersForSuperAdminCheckQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, default_role: string, active: boolean }> };


export const GetOrgUsersForSuperAdminCheckDocument = gql`
    query GetOrgUsersForSuperAdminCheck($where: users_bool_exp!) {
  users(where: $where) {
    id
    default_role
    active
  }
}
    `;

/**
 * __useGetOrgUsersForSuperAdminCheckQuery__
 *
 * To run a query within a React component, call `useGetOrgUsersForSuperAdminCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgUsersForSuperAdminCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgUsersForSuperAdminCheckQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOrgUsersForSuperAdminCheckQuery(baseOptions: Apollo.QueryHookOptions<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables> & ({ variables: GetOrgUsersForSuperAdminCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>(GetOrgUsersForSuperAdminCheckDocument, options);
      }
export function useGetOrgUsersForSuperAdminCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>(GetOrgUsersForSuperAdminCheckDocument, options);
        }
// @ts-ignore
export function useGetOrgUsersForSuperAdminCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>;
export function useGetOrgUsersForSuperAdminCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgUsersForSuperAdminCheckQuery | undefined, GetOrgUsersForSuperAdminCheckQueryVariables>;
export function useGetOrgUsersForSuperAdminCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>(GetOrgUsersForSuperAdminCheckDocument, options);
        }
export type GetOrgUsersForSuperAdminCheckQueryHookResult = ReturnType<typeof useGetOrgUsersForSuperAdminCheckQuery>;
export type GetOrgUsersForSuperAdminCheckLazyQueryHookResult = ReturnType<typeof useGetOrgUsersForSuperAdminCheckLazyQuery>;
export type GetOrgUsersForSuperAdminCheckSuspenseQueryHookResult = ReturnType<typeof useGetOrgUsersForSuperAdminCheckSuspenseQuery>;
export type GetOrgUsersForSuperAdminCheckQueryResult = Apollo.QueryResult<GetOrgUsersForSuperAdminCheckQuery, GetOrgUsersForSuperAdminCheckQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getOrgUsersForSuperAdminCheck.query.gql}
 */
export async function getOrgUsersForSuperAdminCheck(
  variables: GetOrgUsersForSuperAdminCheckQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOrgUsersForSuperAdminCheckQuery['users']>
export async function getOrgUsersForSuperAdminCheck(
  variables: GetOrgUsersForSuperAdminCheckQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOrgUsersForSuperAdminCheckQuery>
export async function getOrgUsersForSuperAdminCheck(
  variables: GetOrgUsersForSuperAdminCheckQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOrgUsersForSuperAdminCheckQuery['users'] | GetOrgUsersForSuperAdminCheckQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOrgUsersForSuperAdminCheckQuery>(
    GetOrgUsersForSuperAdminCheckDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users
}